import { render, staticRenderFns } from "./imgFullWidth.vue?vue&type=template&id=77d11fff&"
import script from "./imgFullWidth.vue?vue&type=script&lang=js&"
export * from "./imgFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports